import { Autocomplete, FormHelperText, TextField, TextFieldProps } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
export interface IOptionInObject {
  options: { [key: string]: string }[];
  autoCompleteField: string;
}

export interface ITagsInput {
  initialValue: string[];
  optionsInStringArray?: string[];
  optionsInObject?: IOptionInObject;
  onTagsChange?: (args: string[]) => void;
  placeholder?: string;
  multiple?: boolean;
  limitTags?: number;
  name: string;
}

const TagsInput: React.FC<ITagsInput & TextFieldProps> = ({
  initialValue,
  optionsInStringArray = [],
  optionsInObject,
  onTagsChange,
  placeholder,
  multiple,
  limitTags,
  name,
  ...props
}) => {
  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = useFormContext();

  register(name, {
    onBlur: () => {
      if (tagsValue.length < 1) {
        const tag = Array.from(new Set([...tagsValue, tempVal]));
        setTagsValue(tag);
        setValue(name, tag);
      }
    },
  });

  const [tempVal, setTempVal] = React.useState<string>('');

  const [tagsValue, setTagsValue] = React.useState<string[]>([]);

  const holder = placeholder ? placeholder : '';

  useEffect(() => {
    setTagsValue(initialValue);
  }, [initialValue]);

  const handleOptionsInObject = (options: IOptionInObject) => {
    return options.options.map(
      (option: { [key: string]: string }) => option[options ? options.autoCompleteField : 'text']
    );
  };

  const handleOnChange = (newValue: string | string[] | null, onChange: (args: any) => void) => {
    if (newValue) {
      if (typeof newValue === 'string') {
        setTagsValue([newValue]);
        onTagsChange && onTagsChange([newValue]);
        onChange([...tagsValue]);
      } else {
        setTagsValue(newValue);
        onTagsChange && onTagsChange(newValue);
        onChange(newValue);
      }
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    switch (event.key) {
      case ',': {
        event.preventDefault();
        event.stopPropagation();
        setTagsValue([...tagsValue, (event.target as HTMLInputElement).value]);
        onTagsChange && onTagsChange([...tagsValue, (event.target as HTMLInputElement).value]);
        break;
      }
      default:
    }
  };

  const handleOptionLabel = (option: string | string[]) => {
    if (typeof option === 'string') {
      return option;
    }
    return option[0] ? option[0] : '';
  };

  const getError = () => {
    let err = null;
    if (errors) {
      const errData = errors[name];
      if (!Array.isArray(errData)) {
        err = <FormHelperText error>{errors[name]?.message}</FormHelperText>;
      } else if (Array.isArray(errData)) {
        errors[name].map((eachErr: { message: string; ref: string; type: string }) => {
          err = <FormHelperText error>{eachErr.message}</FormHelperText>;
        });
      }
    }
    return err;
  };

  return (
    <>
      <Controller
        render={({ field: { onChange, value, onBlur } }) => (
          <Autocomplete
            multiple={multiple}
            limitTags={limitTags}
            freeSolo
            options={
              optionsInObject ? handleOptionsInObject(optionsInObject) : optionsInStringArray
            }
            getOptionLabel={(option) => handleOptionLabel(option)}
            value={value ? value : tagsValue}
            onChange={(event, newValue: string | string[] | null) =>
              handleOnChange(newValue, onChange)
            }
            onBlur={() => onBlur()}
            clearOnBlur={true}
            filterSelectedOptions
            renderInput={(params) => {
              params.inputProps.onKeyDown = handleKeyDown;
              return (
                <TextField
                  {...params}
                  placeholder={holder}
                  onChange={(e) => setTempVal(e.target.value)}
                  {...props}
                />
              );
            }}
          />
        )}
        name={name}
        control={control}
      />
      {getError()}
    </>
  );
};

export default TagsInput;
